import { CalculationStrategy } from "../strategy.class";
export class SquareMeterCalculationStrategy extends CalculationStrategy {
    constructor() {
        super();
    }

    _resolvePrice(variation, customerType) {
        if (customerType === 'contractor' && variation.price.contractor_amount != null) {
            return variation.price.contractor_amount;
        }
        if (variation.price.private_amount != null) {
            return variation.price.private_amount;
        }
        return variation.price.amount;
    }

    calculate(calculationData) {
        const vatMultiplier = calculationData.vatMultiplier || 1.15;
        const unitPrice = this._resolvePrice(calculationData.variation, calculationData.customerType);
        let price_excl_vat = 0.0;
        let price_incl_vat = 0.0;
        let price_vat = 0.0;
        let palettes = 0;

        if (calculationData.receivingType === "collection") {
            let quantity_mod = Math.floor(calculationData.quantity / calculationData.variation.calculation_data.coverage_per_palette);

            price_excl_vat = unitPrice * calculationData.quantity;
            price_incl_vat = price_excl_vat * vatMultiplier;
            price_vat = price_incl_vat - price_excl_vat;

            palettes = quantity_mod;
        } else if (calculationData.receivingType === 'delivery') {
            let quantity_remainder = calculationData.quantity % calculationData.variation.calculation_data.coverage_per_palette;
            let quantity_mod = Math.floor(calculationData.quantity / calculationData.variation.calculation_data.coverage_per_palette);

            if (quantity_remainder > 0) quantity_mod++;

            price_excl_vat = unitPrice * quantity_mod * calculationData.variation.calculation_data.coverage_per_palette;
            price_incl_vat = price_excl_vat * vatMultiplier;
            price_vat = price_incl_vat - price_excl_vat;

            palettes = quantity_mod;
        }

        return {
            price_vat,
            price_excl_vat,
            price_incl_vat,
            palettes
        }
    }
}